/**
 * Current Supplier Reducer
 * Handles single supplier state for viewing/editing
 */

import { SUPPLIERS_ACTION_TYPES } from '../../actions/suppliersActions';

const initialState = {
  supplier: null,
  loading: false,
  error: null,
  isEditing: false,
  isSaving: false
};

const currentSupplierReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUPPLIERS_ACTION_TYPES.LOAD_SUPPLIER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case SUPPLIERS_ACTION_TYPES.LOAD_SUPPLIER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        supplier: action.payload
      };

    case SUPPLIERS_ACTION_TYPES.LOAD_SUPPLIER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        supplier: null
      };

    case SUPPLIERS_ACTION_TYPES.SET_CURRENT_SUPPLIER:
      return {
        ...state,
        supplier: action.payload,
        error: null
      };

    case SUPPLIERS_ACTION_TYPES.CLEAR_CURRENT_SUPPLIER:
      return {
        ...state,
        supplier: null,
        error: null,
        isEditing: false,
        isSaving: false
      };

    case SUPPLIERS_ACTION_TYPES.CREATE_SUPPLIER_REQUEST:
    case SUPPLIERS_ACTION_TYPES.UPDATE_SUPPLIER_REQUEST:
      return {
        ...state,
        isSaving: true,
        error: null
      };

    case SUPPLIERS_ACTION_TYPES.CREATE_SUPPLIER_SUCCESS:
    case SUPPLIERS_ACTION_TYPES.UPDATE_SUPPLIER_SUCCESS:
      return {
        ...state,
        isSaving: false,
        error: null,
        supplier: action.payload,
        isEditing: false
      };

    case SUPPLIERS_ACTION_TYPES.CREATE_SUPPLIER_FAILURE:
    case SUPPLIERS_ACTION_TYPES.UPDATE_SUPPLIER_FAILURE:
      return {
        ...state,
        isSaving: false,
        error: action.payload
      };

    case SUPPLIERS_ACTION_TYPES.DELETE_SUPPLIER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case SUPPLIERS_ACTION_TYPES.DELETE_SUPPLIER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        supplier: state.supplier && state.supplier.id === action.payload.supplierId ? null : state.supplier
      };

    case SUPPLIERS_ACTION_TYPES.DELETE_SUPPLIER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default currentSupplierReducer;